import styled from "styled-components";
import { DescriptiveBlockWrapped } from "../../components/descriptiveBlock";
import { NewsLetter } from "../../components/newsLetter";
import { RentTable } from "./rentTable";
import { Advantages } from "./advantages";
import { MonthlyOffers } from "../home/monthlyOffers";
import { Videos } from "./videos";
import { Accordion } from "../../components/accordionInfo";
import { useCopertinaQuery } from "../../generated/graphql";

const ImgBanner = styled.img`
  width: 100%;
  height: auto;
`;

export function WhatIsRent() {
  const [copertina] = useCopertinaQuery({
    variables: { id: "7lSyETxs9QFWMAQdMWeHdu" },
  });
  return (
    <>
      <ImgBanner
        src={copertina.data?.copertina?.copertina?.url || ""}
      ></ImgBanner>
      <DescriptiveBlockWrapped id="3TlyHoAbjGXGP5g404x7Nd" />
      <RentTable />
      <Advantages />

      <Videos />
      <Accordion></Accordion>
      <NewsLetter />
    </>
  );
}
